let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("dsiAd"), load("8Dqf0")]).then(() => parcelRequire('jOclj'));